<div>
  <form [formGroup]="gstUpdateForm">
    <mat-card>
      <mat-card-content>
        <mat-table formArrayName="gstDetails" [dataSource]="gstDetailsDatasource">
          <ng-container matColumnDef="gstWef">
            <mat-header-cell *matHeaderCellDef>GST WEF</mat-header-cell>
            <mat-cell *matCellDef="let element,let i=index" [formGroupName]="i">
              @if (element.get('id').value) {
                <mat-form-field appearance="fill">
                  <input matInput formControlName="gstWef" required autocomplete="off" readonly>
                  @if (gstDetails.controls[i].get('gstWef').errors?.required) {
                    <mat-error class="mt-1">
                      Required
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (!element.get('id').value) {
                <mat-form-field appearance="fill" style="margin-bottom: 12%;">
                  <input (dateChange)="dateChangeEvent($event,element,'gstWef')" matInput [matDatepicker]="picker" formControlName="gstWef" required autocomplete="off" readonly>
                  <mat-datepicker-toggle matSuffix [for]="picker" readonly></mat-datepicker-toggle>
                  <mat-datepicker #picker readonly></mat-datepicker>
                  @if (gstDetails.controls[i].get('gstWef').errors?.required) {
                    <mat-error class="mt-1">
                      Required
                    </mat-error>
                  }
                </mat-form-field>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="gstWet">
            <mat-header-cell *matHeaderCellDef>GST WET</mat-header-cell>
            <mat-cell *matCellDef="let element,let i=index" [formGroupName]="i">
              @if (!element.get('show').value) {
                <mat-form-field appearance="fill">
                  <input matInput formControlName="gstWet" autocomplete="off" readonly>
                  @if (gstDetails.controls[i].get('gstWet').errors?.required) {
                    <mat-error class="mt-1">
                      Required
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (element.get('show').value) {
                <mat-form-field appearance="fill" style="margin-bottom: 12%;">
                  <input (dateChange)="dateChangeEvent($event,element,'gstWet')" matInput [matDatepicker]="picker1" formControlName="gstWet" autocomplete="off" readonly>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  @if (gstDetails.controls[i].get('gstWet').errors?.required) {
                    <mat-error class="mt-1">
                      Required
                    </mat-error>
                  }
                </mat-form-field>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="sgst">
            <mat-header-cell *matHeaderCellDef>SGST %</mat-header-cell>
            <mat-cell *matCellDef="let element;let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <input matInput formControlName="sgst" autocomplete="off" required [readonly]="element.get('id').value">
                @if (gstDetails.controls[i].get('sgst').errors?.required) {
                  <mat-error class="mt-1">
                    Required
                  </mat-error>
                }
                @if (gstDetails.controls[i].get('sgst').errors?.pattern) {
                  <mat-error class="mt-1">
                    Enter Valid SGST
                  </mat-error>
                }
              </mat-form-field>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="cgst">
            <mat-header-cell *matHeaderCellDef>CGST %</mat-header-cell>
            <mat-cell *matCellDef="let element;let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <input matInput formControlName="cgst" autocomplete="off" required [readonly]="element.get('id').value">
                @if (gstDetails.controls[i].get('cgst').errors?.required) {
                  <mat-error class="mt-1">
                    Required
                  </mat-error>
                }
                @if (gstDetails.controls[i].get('cgst').errors?.pattern) {
                  <mat-error class="mt-1">
                    Enter Valid CGST
                  </mat-error>
                }
              </mat-form-field>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="igst">
            <mat-header-cell *matHeaderCellDef>IGST %</mat-header-cell>
            <mat-cell *matCellDef="let element;let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <input matInput formControlName="igst" autocomplete="off" required [readonly]="element.get('id').value">
                @if (gstDetails.controls[i].get('igst').errors?.required) {
                  <mat-error class="mt-1">
                    Required
                  </mat-error>
                }
                @if (gstDetails.controls[i].get('igst').errors?.pattern) {
                  <mat-error class="mt-1">
                    Enter Valid IGST
                  </mat-error>
                }
              </mat-form-field>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index;">{{row.id}}
              @if (!row.get('id').value) {
                <span class="__action_delete_icon" (click)="removeGstDetailField(i)" matTooltip="Remove this GST Detail">
                  <mat-icon>delete_forever</mat-icon>
                </span>
              }
              @if (dataToPatch.length==i+1) {
                <span style="margin-left: 10px;" class="__action_add_icon" (click)="addGstDetailField(row)" matTooltip="Add GST Detail">
                  <mat-icon mat-cell>add_circle</mat-icon>
                </span>
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="gstDetailColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: gstDetailColumns"></mat-row>
        </mat-table>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="primary" [disabled]="dataToPatch?.length==gstDetails.length" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
        <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
